import $ from 'jquery';

var ToggleAllWidget = (function () {
  var init = function () {
    var toggleBtn = $('.js__select-all-dropdown-toggle');

    toggleBtn.on('click', function () {
      var dropdownSelect = $(`.${$(this).data('dropdown-select')}`);
      if ($(this).hasClass('checked')) {
        removeAllItems(dropdownSelect);
      } else {
        addAllItems(dropdownSelect);
      }
    });
  };

  var addAllItems = function (select) {
    select.dropdown('set selected', getSelectItems(select));
  };

  var removeAllItems = function (select) {
    select.dropdown('remove selected', getSelectItems(select));
  };

  var getSelectItems = function (select) {
    var items = [];

    select.find('select option').each(function () {
      items.push($(this).val());
    });

    return items;
  };

  return {
    init: init,
  };
})();

export default ToggleAllWidget;
